var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPosition && !_vm.currentPosition.valid)?_c('div',{staticStyle:{"float":"right","padding-right":"2px"}},[_c('el-tooltip',{attrs:{"content":_vm.$t('No GPS')}},[_c('i',{staticClass:"fas fa-location-crosshairs-slash",staticStyle:{"padding-left":"2px","color":"red"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }